import {  getQueryParams, httpApi } from '@api/FW/http.api';
import { IQuickActionsItem } from '@components/shared/QuickActions/types';

/**
 * Fetch all the users quick actions.
 */
export const getAllQuickActions = (): Promise<IQuickActionsItem[]> => {
	return httpApi
		.get(`QuickAction/LIST`, {
			params: getQueryParams(),
		})
		.then(({ data }) => {
			return data;
		})
		.catch((err) => {
			throw err;
		});
};

/**
 * Toggle single quick action item.
 */
export const toggleQuickActions = (actionId: string) => {
	return httpApi
		.post(
			`QuickAction/TOGGLE`,
			{ Id: actionId },
			{
				params: getQueryParams(),
			},
		)
		.then(({ data }) => {
			return data;
		})
		.catch((err) => {
			throw err;
		});
};
